import lazyWithRetry from '../utils/lazyWithRetry';

const UserManagement = lazyWithRetry(() => import('../pages/UserManagement'));
const Profile = lazyWithRetry(() => import('../pages/Profile'));
const ResultPage = lazyWithRetry(() => import('../pages/ProjectDetails/Components/ResultPage'));
const ChangeAnalysis = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/ChangeAnalysis'),
);
const GenerateDocument = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/GenerateDocument'),
);
const SubscriptionPlan = lazyWithRetry(() => import('../pages/SubscriptionPlan'));
const EnterprisePlan = lazyWithRetry(() => import('../pages/EnterprisePlan'));
const Organization = lazyWithRetry(() => import('../pages/Organization'));
const OrganizationInclusions = lazyWithRetry(() => import('../pages/OrganizationInclusions'));
const VendorManagement = lazyWithRetry(() => import('../pages/VendorManagement'));
const ScrubPlanNetwork = lazyWithRetry(() =>
	import('../pages/ProductOwner/Components/ScrubPlanNetwork'),
);
const ExclusivityReviewSettings = lazyWithRetry(() =>
	import('../pages/ProductOwner/Components/ExclusivityReviewSettings'),
);
const EnterpriseBillings = lazyWithRetry(() => import('../pages/EnterpriseBillings'));
const SearchPage = lazyWithRetry(() => import('../pages/ProjectDetails/Components/SearchPage'));
const Dashboard = lazyWithRetry(() => import('../pages/Dashboard'));
const ProjectManagement = lazyWithRetry(() => import('../pages/ProjectManagement'));
const Trade = lazyWithRetry(() => import('../pages/TradeManagement'));
const TradeView = lazyWithRetry(() => import('../pages/TradeManagement/Components/View'));
const ProjectDetails = lazyWithRetry(() => import('../pages/ProjectDetails'));
const ProdOwnerOrgDetails = lazyWithRetry(() =>
	import('../pages/ProductOwner/Components/ProdOwnerOrgDetails'),
);
const InteractiveReview = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/CanonicalInteractiveReviewAdapter'),
);
const GroupingInteractiveReview = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/CanonicalGroupingInteractiveReview'),
);
const ChangeAnalysisOverlay = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/ChangeAnalysisOverlay'),
);
const ChangeLogOverlay = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/ChangeLogOverlay'),
);
const MultiPackageInteractiveReview = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/MultiPackageReviewRoute'),
);
const ExclusivityReview = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/ExclusivityReview'),
);
const DrawingsViewer = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/DrawingsViewer'),
);
const ChangePassword = lazyWithRetry(() => import('../pages/ChangePassword'));
const Signout = lazyWithRetry(() => import('../pages/SignOut'));
const ProductOwner = lazyWithRetry(() => import('../pages/ProductOwner'));
const NewDetailsResultPage = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/NewDetailsResultPage'),
);
const BidPackageData = lazyWithRetry(() =>
	import('../pages/ProjectDetails/Components/BidPackageData'),
);

export default [
	{
		exact: true,
		name: 'Dashboard',
		path: '/home',
		Component: Dashboard,
	},
	{
		exact: true,
		name: 'Trade',
		path: '/trade',
		Component: Trade,
	},
	{
		exact: true,
		name: 'Trade View',
		path: '/trade-view/:tradeId',
		Component: TradeView,
	},
	{
		exact: true,
		name: 'ProjectManagement',
		path: '/project',
		Component: ProjectManagement,
	},
	{
		exact: true,
		name: 'ProjectDetails',
		path: '/project/:projectId',
		Component: ProjectDetails,
	},
	{
		exact: true,
		name: 'InteractiveReview',
		path: '/interactive-review',
		Component: InteractiveReview,
	},
	{
		exact: true,
		name: 'ChangeAnalysisOverlay',
		path: '/change-analysis-overlay',
		Component: ChangeAnalysisOverlay,
	},
	{
		exact: true,
		name: 'ChangeLogOverlay',
		path: '/change-log-overlay',
		Component: ChangeLogOverlay,
	},
	{
		exact: true,
		name: 'InteractiveReview',
		path: '/groupig-interactive-review',
		Component: GroupingInteractiveReview,
	},
	{
		exact: true,
		name: 'MultiPackageInteractiveReview',
		path: '/multi-package-interactive-review/:projectId',
		Component: MultiPackageInteractiveReview,
	},
	{
		exact: true,
		name: 'ExclusivityReview',
		path: '/exclusivity-review/:projectId',
		Component: ExclusivityReview,
	},
	{
		exact: true,
		name: 'DrawingsViewer',
		path: '/project/:projectId/drawings/:splitDocumentId',
		Component: DrawingsViewer,
	},
	{
		exact: true,
		name: 'SearchPage',
		path: '/search',
		Component: SearchPage,
	},
	{
		exact: true,
		name: 'ResultPage',
		path: '/result',
		Component: ResultPage,
	},
	{
		exact: true,
		name: 'ChangeAnalysis',
		path: '/changeAnalysis',
		Component: ChangeAnalysis,
	},

	{
		exact: true,
		name: 'Generate Document Page',
		path: '/generateDocument',
		Component: GenerateDocument,
	},

	{
		exact: true,
		name: 'Profile',
		path: '/profile',
		Component: Profile,
	},
	{
		exact: true,
		name: 'UserManagement',
		path: '/user',
		Component: UserManagement,
	},
	{
		exact: true,
		name: 'POdashboard',
		path: '/dashboard',
		Component: ProductOwner,
	},
	{
		exact: true,
		name: 'Subscription Plan',
		path: '/subscriptionPlan',
		Component: SubscriptionPlan,
	},
	{
		exact: true,
		name: 'Enterprise Plan',
		path: '/enterprisePlan',
		Component: EnterprisePlan,
	},
	{
		exact: true,
		name: 'Organization',
		path: '/organization/:id',
		Component: Organization,
	},
	{
		exact: true,
		name: 'Organization Inclusions',
		path: '/organization-inclusions',
		Component: OrganizationInclusions,
	},
	{
		exact: true,
		name: 'Vendor Management',
		path: '/vendor-management',
		Component: VendorManagement,
	},
	{
		exact: true,
		name: 'ScrubPlan Network',
		path: '/scrubplan-network',
		Component: ScrubPlanNetwork,
	},
	{
		exact: true,
		name: 'Exclusivity Review Settings',
		path: '/exclusivity-review-settings',
		Component: ExclusivityReviewSettings,
	},

	{
		exact: true,
		name: 'Enterprise Billings',
		path: '/enterprise-billings',
		Component: EnterpriseBillings,
	},
	{
		exact: true,
		name: 'ChangePassword',
		path: '/changepassword',
		Component: ChangePassword,
	},
	{
		exact: true,
		name: 'Signout',
		path: '/signout',
		Component: Signout,
	},
	{
		exact: true,
		name: 'NewDetailsResultPage',
		path: '/newDetailsResult',
		Component: NewDetailsResultPage,
	},
	{
		exact: true,
		name: 'ProdOwnerOrgDetails',
		path: '/prodOwnerOrgDetails',
		Component: ProdOwnerOrgDetails,
	},
	{
		exact: true,
		name: 'BidPackageData',
		path: '/project/:projectId/bidPackageData/:id',
		Component: BidPackageData,
	},
];
